export default function IconLogoutAndSuccess(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (978 / 444.841) : 978}
      height={height ? height : width ? width * (444.841 / 978) : 444.841}
      viewBox="0 0 978 444.841"
    >
      <g>
        <g fill="#2c0313">
          <path d="M49.582 72.738h129.982a6.456 6.456 0 0 0 0-12.912H49.582a6.456 6.456 0 0 0 0 12.912Z" />
          <path d="M49.582 115.42h129.982a6.456 6.456 0 1 0 0-12.912H49.582a6.456 6.456 0 0 0 0 12.912Z" />
          <path d="M349.315 104.222 248.773 3.622a6.445 6.445 0 0 0-4.562-1.9H30.989A29.32 29.32 0 0 0 1.722 31.034v382.774a29.32 29.32 0 0 0 29.267 29.314h290.953a29.32 29.32 0 0 0 29.267-29.312V108.795a6.779 6.779 0 0 0-1.894-4.569Zm-98.648-80.43 78.419 78.538h-67.659a10.772 10.772 0 0 1-10.76-10.776V23.792Zm87.63 390.016a16.36 16.36 0 0 1-16.355 16.38H30.989a16.36 16.36 0 0 1-16.355-16.38V31.034a16.36 16.36 0 0 1 16.355-16.38h206.766v76.9a23.677 23.677 0 0 0 23.672 23.708h76.87Z" />
          <path d="M30.989 0h213.222a8.116 8.116 0 0 1 5.779 2.4l100.584 100.651a8.457 8.457 0 0 1 2.357 5.746v305.008a31.047 31.047 0 0 1-30.989 31.035H30.989A31.047 31.047 0 0 1 0 413.805V31.035A31.047 31.047 0 0 1 30.989 0Zm317.085 105.423L247.556 4.84a4.7 4.7 0 0 0-3.345-1.392H30.989A27.6 27.6 0 0 0 3.443 31.035v382.77a27.6 27.6 0 0 0 27.546 27.587h290.952a27.6 27.6 0 0 0 27.546-27.587V108.8a5.087 5.087 0 0 0-1.413-3.377ZM30.989 12.931h208.487v78.623a21.929 21.929 0 0 0 21.951 21.983h78.592v300.268a18.064 18.064 0 0 1-18.077 18.1H30.989a18.079 18.079 0 0 1-18.077-18.1V31.035a18.064 18.064 0 0 1 18.077-18.1Zm205.044 3.449H30.989a14.637 14.637 0 0 0-14.634 14.655v382.77a14.637 14.637 0 0 0 14.634 14.656h290.952a14.637 14.637 0 0 0 14.634-14.656V116.986h-75.148a25.393 25.393 0 0 1-25.394-25.432Zm12.912 3.251 84.3 84.424h-71.818a12.505 12.505 0 0 1-12.482-12.5Zm75.985 80.975-72.541-72.65v63.6a9.055 9.055 0 0 0 9.038 9.052Z" />
        </g>
        <g>
          <path
            fill="#04734d"
            d="M176.467 375.436a105.277 105.277 0 1 1 105.277-105.277 105.4 105.4 0 0 1-105.277 105.277Zm-44.636-105.9a6.55 6.55 0 0 0-4.632 11.182l24.214 24.214a18.638 18.638 0 0 0 13.189 5.462c.44 0 .884-.016 1.32-.047a18.668 18.668 0 0 0 13.611-7.416l46.81-62.533a6.552 6.552 0 0 0-5.237-10.477 6.636 6.636 0 0 0-2.893.668 6.463 6.463 0 0 0-2.356 1.958l-46.806 62.527a5.569 5.569 0 0 1-4.054 2.209c-.132.01-.264.014-.393.014a5.519 5.519 0 0 1-3.928-1.628l-24.212-24.215a6.515 6.515 0 0 0-4.633-1.917Z"
          />
        </g>
        <g>
          <path
            fill="#2c0313"
            d="M887.721 412.53h-83.67a8.608 8.608 0 1 1 0-17.216h83.67a19.3 19.3 0 0 0 19.282-19.282v-27.89a8.608 8.608 0 0 1 17.216 0v27.89a36.539 36.539 0 0 1-36.498 36.498Z"
          />
          <path
            fill="#2c0313"
            d="M915.612 132.965a8.608 8.608 0 0 1-8.608-8.608v-27.89a19.3 19.3 0 0 0-19.283-19.282h-83.67a8.608 8.608 0 1 1 0-17.216h83.67a36.539 36.539 0 0 1 36.5 36.5v27.89a8.608 8.608 0 0 1-8.609 8.606Z"
          />
          <path
            fill="#2c0313"
            d="M734.513 440.416a22.333 22.333 0 0 1-3.627-.3l-167.121-23.054a22.685 22.685 0 0 1-19.332-22.6V68.116a22.536 22.536 0 0 1 17.743-21.831L729.289 4.994a22.96 22.96 0 0 1 5.036-.573 22.568 22.568 0 0 1 22.553 22.505v391.093a22.382 22.382 0 0 1-22.367 22.4Zm-.187-418.749a5.339 5.339 0 0 0-1.138.123L566.072 63.078a5.4 5.4 0 0 0-4.425 5.184v326.293a5.388 5.388 0 0 0 4.554 5.438l167.253 23.078 1.057.1a5.155 5.155 0 0 0 5.151-5.158V26.962a5.341 5.341 0 0 0-5.337-5.294Z"
          />
          <path
            fill="#2c0313"
            d="M971.391 244.832H817.996a8.608 8.608 0 1 1 0-17.216h132.617l-41.089-41.085a8.608 8.608 0 0 1 12.174-12.174l55.78 55.78a8.608 8.608 0 0 1-6.087 14.695Z"
          />
          <path
            fill="#04734d"
            d="M971.391 244.832H817.996a8.608 8.608 0 1 1 0-17.216h132.617l-41.089-41.085a8.608 8.608 0 0 1 12.174-12.174l55.78 55.78a8.608 8.608 0 0 1-6.087 14.695Z"
          />
          <path
            fill="#2c0313"
            d="M915.611 300.714a8.608 8.608 0 0 1-6.087-14.695l55.781-55.78a8.608 8.608 0 0 1 12.173 12.174l-55.781 55.78a8.581 8.581 0 0 1-6.086 2.521Z"
          />
          <path
            fill="#04734d"
            d="M915.611 300.714a8.608 8.608 0 0 1-6.087-14.695l55.781-55.78a8.608 8.608 0 0 1 12.173 12.174l-55.781 55.78a8.581 8.581 0 0 1-6.086 2.521Z"
          />
          <path
            fill="#2c0313"
            d="M676.222 237.307a15.581 15.581 0 0 1 0-31.161v13.945Z"
          />
          <path
            fill="#2c0313"
            d="M676.222 237.307v-31.161a15.581 15.581 0 1 1 0 31.161Z"
          />
        </g>
      </g>
    </svg>
  );
}
